import React from 'react'
import { Table, Menu, ActionIcon, Badge, Image, Group, Text } from '@mantine/core'
import { IconDotsVertical, IconPencil, IconTrash } from '@tabler/icons-react'

const ActionMenu = ({ handleAction, detail }) => {
    return (
        <Menu width={200} position="bottom-end" withArrow arrowPosition="center">
            <Menu.Target>
                <ActionIcon ml={8} pt={6} variant='transparent' size='xs'>
                    <IconDotsVertical stroke={1.5} />
                </ActionIcon>
            </Menu.Target>
            <Menu.Dropdown>
                <Menu.Item
                    leftSection={<IconPencil stroke={1.5} size={14} />}
                    onClick={() => handleAction('edit')}
                    fw='600'
                    fz={11}
                >
                    Edit
                </Menu.Item>
                <Menu.Item
                    leftSection={<IconTrash stroke={1.5} size={14} color="red" />}
                    onClick={() => handleAction('delete')}
                    fw='600'
                    fz={11}
                    color="red"
                >
                    Delete
                </Menu.Item>
            </Menu.Dropdown>
        </Menu>
    )
}

const TablePaymentChannels = ({ label, data, actionMethod }) => {
    const mappingTableHead = (data) => data.map((val, index) => {
        return (<Table.Th key={index} width={val.width !== 'auto' ? val.width : ''}>{val.label}</Table.Th>)
    })

    const mappingDataTable = (data) => data.map((val, index) => {
        return (
            <Table.Tr key={index}>
                <Table.Td>{val.id}</Table.Td>
                <Table.Td>
                    <Group gap="sm">
                        {val.logo_url && <Image src={val.logo_url} w={40} fit="contain" />}
                        <Text fz={13}>{val.name}</Text>
                    </Group>
                </Table.Td>
                <Table.Td>
                    <Badge variant="light" color={val.gateway?.value?.toLowerCase().includes('xendit') ? 'blue' : 'gray'} tt='capitalize' fw='500'>
                        {val.gateway?.label || 'Manual'}
                    </Badge>
                </Table.Td>
                <Table.Td><ActionMenu handleAction={(type) => actionMethod(val, type)} detail={val} /></Table.Td>
            </Table.Tr>
        )
    })

    return (
        <Table.ScrollContainer minWidth={800} type='native'>
            <Table highlightOnHover withTableBorder style={{ fontSize: '13px' }}>
                <Table.Thead style={{ backgroundColor: '#eeefef' }}>
                    <Table.Tr>
                        {mappingTableHead(label)}
                    </Table.Tr>
                </Table.Thead>
                <Table.Tbody style={{ verticalAlign: 'top' }}>
                    {mappingDataTable(data)}
                </Table.Tbody>
            </Table>
        </Table.ScrollContainer>
    )
}

export default TablePaymentChannels
